module.exports = __webpack_public_path__ + "img/ch32.79647c69.jpg";